<h1 mat-dialog-title>Track Additional Document</h1>
<div mat-dialog-content>
  <p>
    Documents added via this workflow will not automatically recur in the next
    period.
  </p>
  <form>
    <div class="row gutters">
      <mat-form-field class="col-4">
        <mat-label>Entity Type</mat-label>
        <mat-select [formControl]="formControls.controls.entity_type" required>
          <mat-option value="Project">Project</mat-option>
          <mat-option value="Fund">Fund</mat-option>
          <mat-option value="MTE">Middle-Tier Entity</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-8">
        <mat-label>Entity</mat-label>
        <input
          type="text"
          matInput
          [matAutocomplete]="auto"
          [formControl]="formControls.controls.entity_name"
          [disabled]="
            (formControls.controls.entity_type.valueChanges | async) === null
          "
          required />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (entityMap of documentDialogService.entities$ | async; track entityMap) {
            <mat-option
              [value]="entityMap"
              >{{
              entityMap.owned_entity_name?.length
              ? entityMap.owned_entity_name
              : "Unknown Entity"
              }}{{
              entityMap.related_name?.length
              ? " [" + entityMap.related_name + "]"
              : ""
              }}</mat-option
              >
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="row gutters">
        <mat-form-field class="col-4">
          <mat-label>Period</mat-label>
          <input
            matInput
            [matDatepicker]="periodPicker"
            [formControl]="formControls.controls.period"
            required />
          <mat-datepicker-toggle
            [for]="periodPicker"
          matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #periodPicker></mat-datepicker>
          <mat-hint>MM/DD/YYYY</mat-hint>
        </mat-form-field>
        <mat-form-field class="col-4">
          <mat-label>Document Type</mat-label>
          <mat-select [formControl]="formControls.controls.file_type" required>
            @for (docType of documentTrackerService.docTypes$ | async; track docType) {
              <mat-option
                [value]="docType"
                >{{ docType.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-4">
            <mat-label>Subtype</mat-label>
            <mat-select [formControl]="formControls.controls.sub_type" required>
              @for (subType of subTypes; track subType) {
                <mat-option [value]="subType">{{
                  subType.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row gutters">
          <mat-form-field class="col-4">
            <mat-label>Status</mat-label>
            <mat-select
              [formControl]="formControls.controls.doc_status_id"
              required>
              @for (status of statuses; track status) {
                <mat-option [value]="status.id">{{
                  status.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="save()">Save</button>
      <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    </div>
